import Navbar from "@/components/Common/Navbar";
import AdminBreadcrumb from "@/features/admin/components/AdminBreadcrumb";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import ManagerUsage from "../components/TeamManagement/ManagerUsage";
import ManagerOverview from "../components/TeamManagement/ManagerOverview";
import TeamActivityLog from "../components/TeamManagement/TeamActivityLog";
import { Link, useLocation } from "@tanstack/react-router";
import { useMemo } from "react";

export default function SubscriptionManagementContainer() {
  const location = useLocation();

  const currentTab = useMemo(() => {
    if (location.pathname.endsWith("/usage")) return "usage";
    if (location.pathname.endsWith("/activity")) return "activity";
    if (location.pathname.endsWith("/overview")) return "overview";
    return "overview";
  }, [location.pathname]);

  return (
    <main className="scrollbar-thin flex h-screen min-h-0 flex-1 flex-col gap-7 overflow-y-auto p-3 px-4 pr-0 pl-6 transition-all duration-300">
      <div className="mb-5 flex-shrink-0">
        <Navbar subtitle="manager" />
      </div>

      <div className="flex-shrink-0 px-4 transition-all duration-300 md:px-16 lg:px-[120px]">
        <AdminBreadcrumb title={`Subscription Management`} />
      </div>

      <div className="min-h-0 flex-1 px-4 transition-all duration-300 md:px-16 lg:px-[120px]">
        <div className="flex min-h-0 w-full flex-row justify-start gap-8 pb-20">
          <div className="m-auto w-full max-w-[1000px]">
            <Tabs
              defaultValue="overview"
              className="flex h-full flex-col"
              value={currentTab}
            >
              <div className="flex flex-shrink-0 flex-row justify-between">
                <TabsList className="!h-[52px]">
                  <Link
                    to="/manager/subscription-management/overview"
                    className="z-10000 text-neutral-900"
                  >
                    <TabsTrigger
                      value="overview"
                      className="transition-all duration-200"
                    >
                      Overview
                    </TabsTrigger>
                  </Link>

                  <Link
                    to="/manager/subscription-management/usage"
                    className="z-10000 text-neutral-900"
                  >
                    <TabsTrigger
                      value="usage"
                      className="transition-all duration-200"
                    >
                      Usage
                    </TabsTrigger>
                  </Link>

                  <Link
                    to="/manager/subscription-management/activity"
                    className="z-10000 text-neutral-900"
                  >
                    <TabsTrigger
                      value="activity"
                      className="transition-all duration-200"
                    >
                      Activity Log
                    </TabsTrigger>
                  </Link>
                </TabsList>
              </div>

              <TabsContent value="overview" className="min-h-0 flex-1">
                <ManagerOverview />
              </TabsContent>
              <TabsContent value="usage" className="min-h-0 flex-1">
                <ManagerUsage />
              </TabsContent>
              <TabsContent value="activity" className="min-h-0 flex-1">
                <TeamActivityLog />
              </TabsContent>
            </Tabs>
          </div>
        </div>
      </div>
    </main>
  );
}
